"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const typeahead_input_1 = __importDefault(require("../typeahead-input"));
const helpers_1 = require("./helpers");
const use_form_1 = __importDefault(require("../../../form/use-form"));
const constants_1 = require("../../../constants");
const TimeInput = ({ path }) => {
    const [{ config }] = (0, use_form_1.default)(path);
    const times = config.start && config.end
        ? (0, helpers_1.generateTimes)({
            start: config.start,
            end: config.end,
            step: config.step // TODO - include in config type
        })
        : [];
    return (react_1.default.createElement(typeahead_input_1.default, { type: constants_1.FIELD_TYPE_NAMES.TIME, path: path, items: times, hideErrorsUntilBlur: true }));
};
TimeInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = TimeInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map